export function createLDContexts(userId, companyId) {
    const isValidUser = userId && companyId;
    const commonCustomAttributes = {
      app: "web",
    }

    const userContext = isValidUser
      ?  {
          kind: 'user',
          key: `${userId}`,
          companyId,
          ...commonCustomAttributes,
        }
      : {
          kind: 'user',
          key: 'anonymous',
          anonymous: true,
          ...commonCustomAttributes,
        };

    return userContext;
  }
  